import React from "react";

interface InfoRowProps {
  icon: React.ReactNode;
  label: string;
  value: string;
}

const InfoRow = ({ icon, label, value }: InfoRowProps) => (
  <div className="flex items-start gap-4">
    <div className="p-2.5 bg-gray-50 text-gray-400 rounded-xl group-hover:bg-primary/10 group-hover:text-primary transition-colors">
      {icon}
    </div>
    <div>
      <p className="text-[10px] font-black uppercase tracking-widest text-gray-300 mb-0.5">
        {label}
      </p>
      <p className="font-bold text-gray-700">{value}</p>
    </div>
  </div>
);

export default InfoRow;
